import React from 'react';
import Axios from 'axios';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody} from 'reactstrap';
import CountUp, { useCountUp } from 'react-countup';
import moment from 'moment';

// debug
const CST_FILTER_ZERO_METERS = true;	// default: true

const cstTableHeaders = ['#', 'Date', 'Mètres', 'Activité'];
const cstDefaultSortOrder = ['', 'desc', 'desc', 'asc'];
const cstDefaultSortFieldIdx = 1;


class MontQvneaPlayerProgramsModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			mqPrograms: [],
			totalMeters: 0,
			nextObjectiveMeters: 0,
			mqLevel: {},
/*
			mqLevel: {
				name: "", 
				logo: "",
				meters: 0
			},
*/
			selectedYear: this.props.selectedYear,
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],

			disableSubmit: false
		};

		this.createHdrRow = this.createHdrRow.bind(this);
		this.createTableRow = this.createTableRow.bind(this);
		this.handleYearChange = this.handleYearChange.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
		//console.log('MontQvneaPlayerProgramsModal: componentDidMount');
		var playerId = this.props.programsModalPlayer._id;
		var selectedYear = this.props.selectedYear;
		this.loadProgramsData(playerId, selectedYear);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('MontQvneaPlayerProgramsModal: UNSAFE_componentWillReceiveProps');
		var playerId = nextProps.programsModalPlayer._id;
		var selectedYear = nextProps.selectedYear;
		this.loadProgramsData(playerId, selectedYear);
	}

	loadProgramsData(playerId, selectedYear) {
		var _this = this;
		Axios.get('/api/qvnea/montQvneaPrograms/playerId/' + playerId + '/year/' + selectedYear).then(function(mqProgramResponse) {

			var mqProgramObjects = mqProgramResponse.data;

			if (CST_FILTER_ZERO_METERS) {
				mqProgramObjects = mqProgramObjects.filter(mqp => (mqp.meters !== 0));
			}

			// Build data table
			var mqPrograms = [];
			var totalMeters = 0;
			mqProgramObjects.forEach(function (mqDataRow, mqDataRowIdx) {

				var mqProgramsRow = [];
				mqProgramsRow.push(0);
				mqProgramsRow.push(mqDataRow.date);
				mqProgramsRow.push(mqDataRow.meters);
				mqProgramsRow.push(mqDataRow.programName);
				totalMeters += mqDataRow.meters;

				mqPrograms.push(mqProgramsRow);
			});

			// Determine Mont Qvnea level to get the appropriate logo to display in the top right corner
			var mqLevel = {};
			var mqLevels = _this.props.mqLevels;
			var nextObjectiveMeters = 0;
			for (var mqlIdx = (mqLevels.length - 1); mqlIdx >= 0; mqlIdx--) {
				if (totalMeters >= mqLevels[mqlIdx].meters) {
					mqLevel = mqLevels[mqlIdx];
					if (mqlIdx !== 0) {
						nextObjectiveMeters = mqLevels[mqlIdx-1].meters - totalMeters;
					} else {
						nextObjectiveMeters = 0;
					}
				}
			}

			_this.setState({
				nextObjectiveMeters: nextObjectiveMeters,
				selectedYear: selectedYear,
				mqLevel: mqLevel,
				totalMeters: totalMeters,
			});

			_this.sortPrograms(mqPrograms, _this.state.sortFieldIdx, _this.state.sortOrder);
		});

	}

	sortPrograms(mqPrograms, sortFieldIdx, sortOrder) {

		var _this = this;
		var sortSign = 1;
		if (sortOrder === 'desc') { 
			sortSign = -1; 
		}

		// Sort programs
		mqPrograms.sort(function (a, b) {

			var valueA = 0;
			var valueB = 0;

			var fact1 = 0;
			var fact2 = 0;

			// Criteria #1
			valueA = a[sortFieldIdx];
			valueB = b[sortFieldIdx];

			switch(typeof valueA) {
		    case "date":
					fact1 = sortSign * (new Date(valueA) - new Date(valueB));
					fact2 = a[2].localeCompare(b[2]);
	        break;

		    case "string":
					fact1 = sortSign * (valueA.localeCompare(valueB));
					fact2 = new Date(b[1]) - new Date(a[1]);
  	      break;

		    case "number":
					fact1 = sortSign * (valueA - valueB);
					fact2 = new Date(b[1]) - new Date(a[1]);
	        break;

		    default:
	        break;
			}

			// Results
			if (fact1 !== 0) {
				return fact1;
			} else {
				return fact2;
			}
		});


		_this.setState({
			mqPrograms: mqPrograms,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
			disableSubmit: false
		});
	}

	render() {
		// console.log('MontQvneaPlayerProgramsModal: render');
		// console.log(this.state.rating);
		// console.log(this.props.programsModalPlayer);

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size="lg"
    		className={this.props.className}>

    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			Mont QVNEA - Activités du joueur
    		</ModalHeader>

    		<ModalBody>
					{this.dispPlayerProgram()}
    		</ModalBody>

    		<ModalFooter>
{/*
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
*/}
      		<button className="btn btn-primary btn-sm stdCommandButton2 btn-extra-padding" 
      			onClick={this.props.handleModalCancel}> OK
      		</button>
    		</ModalFooter>
    	</Modal>
    )
	}

	dispPlayerProgram() {

		var mqPrograms = this.state.mqPrograms;
		var totalMeters = this.state.totalMeters;
		var nextObjectiveMeters = this.state.nextObjectiveMeters;
		var nextObjMetresTxt = "mètre" + ((nextObjectiveMeters > 1) ? "s" : "");

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-md-9">
					<h5> {this.props.programsModalPlayer.name} </h5>
					<p>
       			Choisir une saison, cliquer sur l'entête d'une table pour consulter la 
       			liste des joueurs qui ont atteint ce dernier. Cliquer sur les entêtes de colonne pour trier les activités.
					</p>

        	{this.dispYearsSelector()}
					<br/>

	        <div className="row row-margin-bottom-10">
	        <div className="col-md-4 col-6">

						<strong className="mqvnea-prog-meters-title"> Activités </strong>
						<CountUp
						  start={0} end={mqPrograms.length} delay={0} duration={5}
						  separator="" decimals={0} decimal="," prefix="" suffix="">
						  {({ countUpRef }) => (
						    <div>
						      <span className="mqvnea-prog-meters-number" ref={countUpRef} /><br/><br/>
						    </div>
						  )}
						</CountUp>
					</div>

	        <div className="col-md-4 col-6">

						<strong className="mqvnea-prog-meters-title"> Mètres </strong>
						<CountUp
						  start={0} end={totalMeters} delay={0} duration={5}
						  separator="" decimals={0} decimal="," prefix="" suffix=" m">
						  {({ countUpRef }) => (
						    <div>
						      <span className="mqvnea-prog-meters-number" ref={countUpRef} /><br/><br/>
						    </div>
						  )}
						</CountUp>
					</div>

					</div>
				</div>

				<div className="col-md-3 text-center margin-montqvnea-level-logo">
					{(this.state.mqLevel.logo !== "") ?
						<img className="img-fluid" src={this.state.mqLevel.logo} alt="leaders" width="200"/>
					: null}
					
					<br/><br/>
					{(this.state.nextObjectiveMeters !== 0) ?
						<strong> Prochain objectif <br/>dans {nextObjectiveMeters} {nextObjMetresTxt} </strong>
						: null}

				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<div className="tableFixHeader tableFixHeader-montQvnea">
					<table className="table table-hover table-sm">
						<thead>
							<tr>{cstTableHeaders.map(this.createHdrRow)}</tr>
						</thead>

						{this.displayTable()}
					</table>
					</div>
					<br/>

				</div>
				</div>
			</div>
		)
	}

	dispYearsSelector() {
		return (
      <div className="row">
      <div className="col-md-7 col-xs-12">
			<span className="small"> <strong> Saison </strong> </span> <br/>
			<select className="form-control form-control-sm" type="text" id="seasonYears" value={this.state.selectedYear} 
				onChange={this.handleYearChange}>
	    	{this.props.years.map((y, yidx) => (
	    		<option key={'yearSelOpt.' + yidx} value={y.value}> {'Saison ' + y.dropdownText} </option> ))}
			</select>
			</div>
			</div>
		)					
	}

	displayTable() {
		var mqPrograms = this.state.mqPrograms;

		if (mqPrograms.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucune activité</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{mqPrograms.map(this.createTableRow)}
				</tbody>
			)
		}
	}

	createHdrRow(hdrItem, hdrIdx) {

		var classNameStr = '';
		var onClickAction = function() {};

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdx) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + hdrIdx} 
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

  createTableRow(progRow, progRowIdx, progRows) {
  	var datef = moment(progRow[1]).utc().format('YYYY-MM-DD');
    return (
      <tr key={'prog.' + progRowIdx}>
        <td>{progRowIdx + 1}</td>
 				<td>{datef}</td>
 				<td>{progRow[2]}</td>
 				<td>{progRow[3]}</td>
      </tr>
    );
  }

	handleYearChange(e) {
 		this.loadProgramsData(this.props.programsModalPlayer._id, e.target.value);
	}

	handleSortTable(e) {

		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortOrder;

		var mqPrograms = this.state.mqPrograms;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortPrograms(this.state.mqPrograms, sortFieldIdx, sortOrder);
	}

}

export default MontQvneaPlayerProgramsModal;